// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  GoogleAuthProvider,
  getAuth,
  signInWithRedirect,
  signOut,
  sendEmailVerification,
  updateEmail,
  updatePassword,
  sendPasswordResetEmail,
  EmailAuthProvider,
  reauthenticateWithCredential,
  getRedirectResult,
} from "firebase/auth";

import { getDatabase } from 'firebase/database'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyAnT36xKWtZ4JXNST9g-W_4pBjYQaHq2VM",
  authDomain: "tukit00.firebaseapp.com",
  projectId: "tukit00",
  storageBucket: "tukit00.appspot.com",
  messagingSenderId: "161056694845",
  appId: "1:161056694845:web:2e26322c77d7a10e06c054",
  measurementId: "G-XCXD9VE4GM",
  databaseURL: "https://tukit00-default-rtdb.firebaseio.com",
  storageBucket: 'gs://tukit00.appspot.com'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firebase realtime DB
export const db = getDatabase(app)
// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app)
auth.useDeviceLanguage()
export const storage = getStorage(app)

// END DEFINICIONES //

export const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider()
  provider.setCustomParameters({ prompt: 'select_account' })

  return signInWithRedirect(auth, provider)
}

export const logOut = () => signOut(auth)
export const verifyEmail = async () => { return sendEmailVerification(auth.currentUser) }

export const changeEmail = async (password, newEmail) => {
  return reauthenticate(password).then(() => updateEmail(auth.currentUser, newEmail))
}

export const changePassword = async (password, newPassword) => {
  return reauthenticate(password).then(() => updatePassword(auth.currentUser, newPassword))
}

export const reauthenticate = async (password) => {
  const providerId = auth.currentUser.providerData[0].providerId;

  if (providerId === 'password') {
    return emailReauthentication(auth.currentUser, password)
  } else {
    // TODO: Implementar para otros providers
  }
}

export const recoverPassword = async email => {
  return sendPasswordResetEmail(auth, email)
}

const emailReauthentication = async (user, password) => {
  const provider = new EmailAuthProvider()
  const credential = EmailAuthProvider.credential(user.email, password);

  try {
    return reauthenticateWithCredential(user, credential)

  } catch (error) {
    throw error;
  }
}

export default app;